import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs,
} from "@mantine/core";
import {
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconEdit,
  IconUserPlus,
  IconEye,
  IconPhoto,
  IconGiftCard,
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./Voucher.module.css";
import { RowDataVoucher } from "./types";
import { props } from "./props";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { CustomTable } from "../Table/CustomTable";
import { admin, voucher } from "../types/RowDataTypes";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import CreateVoucher from "./CreateVoucher";
import DeleteVoucher from "./DeleteVoucher";
import getVoucherTable from "../../DataDisplay/DataDisplayTable/VoucherTable";
import { useQuery } from 'react-query';
import { useNavigate, useLocation } from "react-router-dom";

enum ColumnHeaderToFilterPair {
  VOUCHER = "Voucher ID",
//   UID = "UID",
//   XID = "XID",
  TITLE = "Title",
  TYPE = "Type",
  AMOUNT = "Amount",
  REMARKS = "Remarks",
  START_DATE = "Start Date",
  END_DATE = "End Date",
  XCODE = "XCode",
  XREDEMPTION_ID = "XRedemptionID",
  XREDEMPTION_TYPE = "XRedemptionType",
  COST = "Cost",
//   IMAGESEARCH = "Image Search",
//   STATUS = "Status",
    QUANTITY = "Quantity",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.VOUCHER]: "voucher_id",
//   [colFilter.UID]: "uid",
//   [colFilter.XID]: "xid",
  [colFilter.TITLE]: "title",
  [colFilter.TYPE]: "type",
  [colFilter.AMOUNT]: "amount",
  [colFilter.REMARKS]: "remarks",
  [colFilter.START_DATE]: "startDate",
  [colFilter.END_DATE]: "endDate",
  [colFilter.XCODE]: "xcode",
  [colFilter.XREDEMPTION_ID]: "xredemptionId",
  [colFilter.XREDEMPTION_TYPE]: "xredemptionType",
  [colFilter.COST]: "cost",
//   [colFilter.IMAGESEARCH]: "imgSrc",
//   [colFilter.STATUS]: "status",
    [colFilter.QUANTITY]: "cost",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  const allowedSorts = [
    colFilter.TITLE.toLowerCase(),
    colFilter.TYPE.toLowerCase(),
    colFilter.AMOUNT.toLowerCase(),
    colFilter.START_DATE.toLowerCase(),
    colFilter.END_DATE.toLowerCase(),
    // colFilter.STATUS.toLowerCase(),
    colFilter.XCODE.toLowerCase(),
    colFilter.COST.toLowerCase(),
  ];

  return (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataVoucher[] = [
  {
    voucher_id: "",
    uid: "",
    xid: "",
    title: "",
    type: "",
    amount: "",
    remarks: "",
    startDate: "",
    endDate: "",
    xCode: "",
    xRedemptionID: "",
    xRedemptionType: "",
    cost: "",
    imageSrc: "",
    status: "",
    action: "",
    numVouchers: "",
    terms_id: "",
    numberOfVoucher: 0,
    numberOfClaimedVoucher: 0,
    
  },
];

export function Voucher() {
  const axiosPrivate = useAxiosPrivate();
  const nav = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState<string>("");
  const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataVoucher | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const getTermsQuery = useQuery(
        "getTerms",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/terms-conditions/read-for-select", { signal })).data.terms,
        {
            initialData: [],
            onSuccess: (res) => {
                console.log(res)
            },
            onError: () => {

            }
        }
    );

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFilters[colFilter.TITLE],
    colFilters[colFilter.REMARKS],
    colFilters[colFilter.XCODE],
  ];
  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    voucher,
    getVoucherTable().create(),
    {
        current: location.pathname.split("/")[2] ?? "ongoing",
    },
  );

  const itemsOnPage = useRef(0);
  const [totalRows, setTotalRows] = useState<number>(0);
  const rowData: RowDataVoucher[] | null = fetchedData.data as RowDataVoucher[];
  const isLoading: boolean = fetchedData.isLoading;
  const [RowDataVoucher, setRowDataVoucher] = useState<RowDataVoucher[] | null>(
    null
  );

  useEffect(() => {
    setRowDataVoucher(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
    setTotalRows(fetchedData.totalRows);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData]);

  // Separate state for the modal related to adding customers
  const [isAddVoucherFormVisible, setAddVoucherFormVisible] = useState(false);

  // Separate state for the modal related to viewing/editing customers
  const [selectedRow, setSelectedRow] = useState<RowDataVoucher | null>(null);
  const [isViewMode, setViewMode] = useState(false);
  const [isEditMode, setEditMode] = useState(false);

  const [isDeleteConfirmationVisible, setDeleteConfirmationVisible] =
    useState(false);
  const [rowToDelete, setRowToDelete] = useState<RowDataVoucher | null>(null);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handleView = (row: RowDataVoucher) => {
    setSelectedRow(row);
    setViewMode(true);
  };

  const handleEdit = (row: RowDataVoucher) => {
    setSelectedRow(row);
    setEditMode(true);
    // Set the initial values for editing based on the selected row
  };

  const handleDelete = (row: RowDataVoucher) => {
    setRowToDelete(row);
    setDeleteConfirmationVisible(true);
  };

  const handleConfirmDelete = () => {
    if (rowToDelete) {
    //   console.log(rowToDelete);
      axiosPrivate
        .post("/api/admin/admin/delete", {
          voucher_id: rowToDelete.uid,
        })
        .then((response) => {
          setDeleteConfirmationVisible(false);
          if (
            itemsOnPage.current == 1 &&
            currentPage !== 1 &&
            currentPage == Math.ceil(totalRows / itemsPerPage)
          )
            setCurrentPage((prev) => prev - 1);
          else changeTableState();
        })
        .catch((err) => {});

      const updatedData = sortedData.filter((row) => row !== rowToDelete);
      setSortedData(updatedData);
      setDeleteConfirmationVisible(false);
    }
  };

  const handleCancelDelete = () => {
    setRowToDelete(null);
    setDeleteConfirmationVisible(false);
  };

  const setSorting = (field: keyof RowDataVoucher) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    changeTableState();
  };

  const startIndex = (currentPage - 1) * itemsPerPage;

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const handleAddVouchers = () => {
    setAddVoucherFormVisible(true);
  };

  const handleAddVoucher = (newVoucherData: RowDataVoucher) => {
    axiosPrivate
      .post(
        "/api/admin/vouchers/generate-vouchers",
        {
          title: newVoucherData.title,
          numberOfVoucher: newVoucherData.numVouchers,
          code: newVoucherData.xCode,
          types: newVoucherData.type,
          amount: newVoucherData.amount,
          remarks: newVoucherData.remarks,
          startDate: newVoucherData.startDate,
          endDate: newVoucherData.endDate,
          cost: newVoucherData.cost,
          terms_id: newVoucherData.terms_id,
          image: newVoucherData.imageSrc,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {

        // const data = res.data.payload;
        // const returnedData: RowDataVoucher = {
        //   ...newVoucherData,
        //   uid: data.voucher_id,
        // };

        // if (itemsOnPage.current < itemsPerPage) {
        //   if (!reverseSortDirection)
        //     setRowDataVoucher((prevData) => [returnedData, ...prevData!!]);
        //   else setRowDataVoucher((prevData) => [...prevData!!, returnedData]);
        // }
        // itemsOnPage.current = itemsOnPage.current + 1;
        // setTotalRows((prevData) => prevData + 1);

        changeTableState();
        // console.log(`after ${itemsOnPage.current}`);
        showSuccessAlert("Voucher Successfully Created");
      })
      .catch((err) => {
        showErrorAlert("An error has occured");
      });

    setSortedData((prevData) => [...prevData, newVoucherData]);

    // Close the modal
    setAddVoucherFormVisible(false);
  };

  const handleSaveChanges = (
    editedData: RowDataVoucher,
    originalData: RowDataVoucher | null
  ) => {
    if (originalData) {
      const paramsToUpdate = {
        voucher_id: originalData.voucher_id,
        uid: originalData.uid,
        xid: originalData.xid,
        title: editedData.title,
        type: editedData.type,
        amount: editedData.amount,
        remarks: editedData.remarks,
        startDate: editedData.startDate,
        endDate: editedData.endDate,
        xCode: originalData.xCode,
        xRedemptionID: editedData.xRedemptionID,
        xRedemptionType: editedData.xRedemptionType,
        cost: editedData.cost,
        imageSearch: editedData.imageSrc,
        status: editedData.status,
      };

      axiosPrivate
        .post("/api/admin/admin/update", paramsToUpdate)
        .then((response) => {
          const indexOfSelectedRow = RowDataVoucher!!.findIndex(
            (row) => row === selectedRow
          );

          // Create a copy of the sortedData
          const updatedData = [...RowDataVoucher!!];
          updatedData[indexOfSelectedRow] = {
            ...editedData,
          };

          // // Set the updated data as the sortedData
          setRowDataVoucher(updatedData);
          // Close the modal and exit edit mode
          setEditMode(false);
          showSuccessAlert("Voucher Successfully Updated");
        })
        .catch((error) => {
          showErrorAlert("An error has occured");
        });
    }

    setEditMode(false);
  };

  const rowsToMap = RowDataVoucher ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td>{row.voucher_id}</Table.Td>
      {/* <Table.Td>{row.uid}</Table.Td>
      <Table.Td>{row.xid}</Table.Td> */}
      <Table.Td>{row.title}</Table.Td>
      <Table.Td>{row.type == "0" ? "Currency" : "Percentage"}</Table.Td>
      <Table.Td>{row.amount}</Table.Td>
      <Table.Td>{row.remarks}</Table.Td>
      <Table.Td>
        {" "}
        {new Date(row.startDate).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
        })}
      </Table.Td>
      <Table.Td>
        {" "}
        {new Date(row.endDate).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
        })}
      </Table.Td>
      <Table.Td>{row.xCode}</Table.Td>
      <Table.Td>{row.xRedemptionID}</Table.Td>
      <Table.Td>{row.xRedemptionType}</Table.Td>
      <Table.Td>{row.cost}</Table.Td>
      {/* <Table.Td>{row.imageSrc}</Table.Td> */}
      {/* <Table.Td>{row.status}</Table.Td> */}
      <Table.Td>{row.numberOfClaimedVoucher}/{row.numberOfVoucher}</Table.Td>
      <Table.Td className={classes.actionButtons}>
        <button onClick={() => handleView(row)} className={classes.viewbutton}>
          <IconEye /> View
        </button>
        {/* <button onClick={() => handleEdit(row)} className={classes.editbutton}>
          <IconEdit /> Edit
        </button>
        <button
          onClick={() => handleDelete(row)}
          className={classes.trashbutton}
        >
          <IconTrash /> Delete
        </button> */}
      </Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };

  const handleTabChange = (val: string | null) => {
    val = val ?? "ongoing";
    nav(`/voucher/${val}`);
    changeTableState();
  };

  return (
    <div className={classes.VoucherContainer}>
      <ScrollArea className={classes.parentContainer}>
        <Header title="Voucher" />
        <div className={classes.searchBarContainer}>
          <SearchBar
            isLoading={isLoading}
            resetPage={resetPage}
            changeTableState={changeTableState}
            search={search}
            handleSearch={handleSearch}
            setShowFilterOptions={setShowFilterOptions}
            showFilterOptions={showFilterOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            checkboxesFilter={checkboxesFilter}
          />

          <div className={classes.addButtonContainer}>
            <Button
              onClick={handleAddVouchers}
              className={classes.addVoucherButton}
            >
              <IconGiftCard style={{ marginRight: "5px" }} /> Create Voucher
            </Button>
          </div>
        </div>

        <Tabs
          defaultValue="ongoing"
          color="blueviolet"
          variant="pills"
          onChange={(value) => {
            handleTabChange(value);
          }}
        >
            <Tabs.List className={classes.tabHeader}>
                <Tabs.Tab value="ongoing" className={classes.tabTitle}>
                    Ongoing
                </Tabs.Tab>
                <Tabs.Tab value="history" className={classes.tabTitle}>
                    History
                </Tabs.Tab>
            </Tabs.List>
          <ScrollArea
            w={
              window.innerWidth -
              document.getElementById("nav-bar")!!.getBoundingClientRect().width
            }
          >
            <Tabs.Panel value="ongoing">
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPair)}
                    filters={Object.values(colFilters)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={sortBy}
                    setSorting={setSorting}
                    customclasses={classes}
                    Th={Th}
                    rowData={rowData}
                    rows={rows}
                />
            </Tabs.Panel>

            <Tabs.Panel value="history">
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPair)}
                    filters={Object.values(colFilters)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={sortBy}
                    setSorting={setSorting}
                    customclasses={classes}
                    Th={Th}
                    rowData={rowData}
                    rows={rows}
                />
            </Tabs.Panel>
          </ScrollArea>

        </Tabs>

        {/* <ScrollArea
          w={
            window.innerWidth -
            document.getElementById("nav-bar")!!.getBoundingClientRect().width
          }
        >
          <CustomTable
            colHeaders={Object.values(ColumnHeaderToFilterPair)}
            filters={Object.values(colFilters)}
            reverseSortDirection={reverseSortDirection}
            sortBy={sortBy}
            setSorting={setSorting}
            customclasses={classes}
            Th={Th}
            rowData={rowData}
            rows={rows}
          />
        </ScrollArea> */}

        <div className={classes.footerContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results`}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>
        <ScrollArea>
          {/* Modal Form for Create, Edit, Delete */}
          <CreateVoucher
            isVisible={isAddVoucherFormVisible}
            onClose={() => setAddVoucherFormVisible(false)}
            onAddVoucher={(newVoucherData) => handleAddVoucher(newVoucherData)}
            terms={getTermsQuery.data}
          />
        </ScrollArea>

        <ScrollArea>
          {isViewMode && (
            <Modal
              opened={true}
              title={
                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                  View
                </div>
              }
              onClose={() => setViewMode(false)}
              size="md"
              padding="lg"
            >
              <div className={classes.addCustomerForm}>
                {/* Display fields for viewing, but disable editing */}
                <TextInput
                  label="Voucher ID"
                  mb="sm"
                  value={selectedRow?.voucher_id}
                  readOnly
                />
                {/* <TextInput
                  label="UID"
                  mb="sm"
                  value={selectedRow?.uid}
                  readOnly
                />
                <TextInput
                  label="XID"
                  mb="sm"
                  value={selectedRow?.xid}
                  readOnly
                /> */}
                <TextInput
                  label="Title"
                  mb="sm"
                  value={selectedRow?.title}
                  readOnly
                />
                <TextInput
                  label="Type"
                  mb="sm"
                //   value={selectedRow?.type}
                  value={selectedRow?.type == "0" ? "Currency" : "Percentage"}
                  readOnly
                />
                <TextInput
                  label="Amount"
                  mb="sm"
                  value={selectedRow?.amount}
                  readOnly
                />
                <TextInput
                  label="Remarks"
                  mb="sm"
                  value={selectedRow?.remarks}
                  readOnly
                />

                <TextInput
                  label="Start Date"
                  mb="sm"
                  value={selectedRow?.startDate}
                  readOnly
                />

                <TextInput
                  label="End Date"
                  mb="sm"
                  value={selectedRow?.endDate}
                  readOnly
                />

                <TextInput
                  label="X Code"
                  mb="sm"
                  value={selectedRow?.xCode}
                  readOnly
                />

                <TextInput
                  label="X Redemption ID"
                  mb="sm"
                  value={selectedRow?.xRedemptionID}
                  readOnly
                />

                <TextInput
                  label="X Redemption Type"
                  mb="sm"
                  value={selectedRow?.xRedemptionType}
                  readOnly
                />

                <TextInput
                  label="Cost"
                  mb="sm"
                  value={selectedRow?.cost}
                  readOnly
                />

                <Text className={classes.Text}>
                  Image <span className={classes.format}>(.jpg, .png)</span>
                </Text>
                <div className={classes.voucherImageContainer}>
                  {selectedRow?.imageSrc ? (
                    <img
                      src={selectedRow?.imageSrc}
                      alt="Banner Image"
                      className={classes.voucherImageSize}
                    />
                  ) : (
                    <p>
                      <IconPhoto />
                    </p>
                  )}
                </div>
                {/* <TextInput
                  label="Status"
                  value={selectedRow?.status}
                  readOnly
                /> */}
                <Select
                    label="Terms & conditions"
                    placeholder="Pick terms & conditions"
                    data={getTermsQuery.data}
                    value={selectedRow?.terms_id}
                    readOnly
                    />
              </div>
            </Modal>
          )}
        </ScrollArea>
        {isDeleteConfirmationVisible && (
          <DeleteVoucher
            isOpen={isDeleteConfirmationVisible}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
          />
        )}
      </ScrollArea>
    </div>
  );
}

export default Voucher;
